export default function pluralize(name) {
    if (/[bcdfghjklmnpqrstvwxyz]y$/i.test(name)) {
        return name.slice(0, -1) + 'ies'
    }

    return name + 's'
}
